import { useMemo, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/logo.png";

const navItems = [
  { label: "Home", href: "/", match: ["/"] },
  { label: "Programs", href: "/#programs", match: ["/"] },
  { label: "Find Tutors", href: "/marketplace", match: ["/marketplace", "/tutor"] },
  { label: "Success Stories", href: "/#success-stories", match: ["/"] },
  { label: "Contact", href: "/#contact", match: ["/"] },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const pathname = useMemo(() => location.pathname, [location.pathname]);
  const isActive = (item) =>
    item.match.some((value) => (value === "/" ? pathname === "/" : pathname.startsWith(value)));

  return (
    <header className="sticky top-0 z-50">
      <div className="top-ribbon">
        <div className="section-shell flex flex-wrap items-center justify-between gap-2 py-2">
          <p>Online Tuition | Admission Consultancy | Live Doubt Support</p>
          <p>Free demo booking within 24 hours</p>
        </div>
      </div>

      <div className="section-shell py-5">
        <div className="header-shell flex flex-wrap items-center justify-between gap-3 px-4 py-4 sm:px-6 xl:flex-nowrap">
          <Link to="/" className="brand-shell gap-4 text-slate-900" aria-label="Dreameer Education home">
            <img src={logo} alt="Dreameer Education logo" className="h-10 w-auto sm:h-12" />
            <div className="hidden text-slate-900 sm:block">
              <div className="text-lg font-extrabold leading-none">Dreameer Education</div>
              <div className="mt-1 text-[11px] font-semibold uppercase tracking-[0.24em] text-slate-500">
                Dream + Career = Dreameer
              </div>
            </div>
          </Link>

          <nav className="hidden flex-wrap items-center gap-2 lg:flex xl:gap-3" aria-label="Primary navigation">
            {navItems.map((item) => {
              const active = isActive(item);
              return (
                <Link
                  key={item.label}
                  to={item.href}
                  className={`header-link ${active ? "bg-navy-900 text-white" : ""}`}
                >
                  {item.label}
                </Link>
              );
            })}
          </nav>

          <div className="hidden items-center gap-3 lg:flex">
            <a href="tel:+919507505612" className="hotline-button">
              Call +91 95075 05612
            </a>
            <Link to="/#book-demo" className="button-ghost">
              Book Demo
            </Link>
          </div>

          <button
            type="button"
            className="inline-flex rounded-full border border-white/15 bg-white/10 px-5 py-3 text-sm font-extrabold text-white shadow-[0_10px_24px_rgba(10,23,60,0.12)] lg:hidden"
            aria-label="Toggle navigation menu"
            aria-expanded={open}
            onClick={() => setOpen((value) => !value)}
          >
            {open ? "Close" : "Menu"}
          </button>
        </div>

        {open ? (
          <div className="header-shell mt-3 p-4 lg:hidden">
            <div className="flex flex-col gap-2">
              {navItems.map((item) => (
                <Link
                  key={item.label}
                  to={item.href}
                  className="rounded-2xl border border-white/10 bg-white/10 px-4 py-3 text-sm font-extrabold text-white"
                  onClick={() => setOpen(false)}
                >
                  {item.label}
                </Link>
              ))}
              <a href="tel:+919507505612" className="hotline-button text-center">
                Call +91 95075 05612
              </a>
              <Link to="/#book-demo" className="button-ghost" onClick={() => setOpen(false)}>
                Book Demo
              </Link>
            </div>
          </div>
        ) : null}
      </div>
    </header>
  );
}
